import { useNavigate } from 'react-router-dom';
import LastUpdated from './LastUpdated';

import HomeIcon from '../../../assets/icons/General/home-icon.svg?react';
import Chevron from '../../../assets/icons/General/chevron.svg?react';
import { Typography } from '../../widgets/Typography';
import { useIsFilterAllowed } from '../HeadingFilter/hooks';

interface IPageHeadingProps {
  title: string;
  subTitle?: string;
  showBackButton?: boolean;
  refreshWidget: () => void;
  meta?: any;
}

function PageHeading({
  title,
  subTitle,
  showBackButton,
  refreshWidget,
  meta,
}: IPageHeadingProps) {
  const navigate = useNavigate();
  const isFilterAllowed = useIsFilterAllowed();

  const isOrgDim2 = subTitle;

  return (
    <>
      {showBackButton && (
        <div className="text-grey-600 mb-5 flex items-center gap-x-2">
          <button
            type="button"
            className="rounded-lg px-2 py-1 hover:bg-blue-50"
            onClick={() => {
              if (isOrgDim2) navigate('/d/dimensions');
              else navigate('/d/dimensions-legacy');
            }}
          >
            <HomeIcon className="fill-grey-500 cursor-pointer" />
          </button>

          <Chevron className={`stroke-grey-300 w-6 -rotate-90`} />

          <span className="rounded-lg px-2 py-1 text-sm font-medium text-blue-700 hover:bg-blue-50">
            {title}
          </span>
        </div>
      )}

      <div className={`flex flex-col ${isFilterAllowed ? 'mb-4' : ''}`}>
        <div className="mb-4 flex flex-col items-center justify-between md:mb-2 md:flex-row">
          <Typography
            variant="display-sm"
            weight="semibold"
            className="text-left"
          >
            {title}
          </Typography>
          <LastUpdated
            lastUpdatedDate={meta?.lastUpdatedAt}
            refreshWidget={refreshWidget}
          />
        </div>
        {subTitle && (
          <div className="text-grey-700 text-pretty">{subTitle}</div>
        )}
      </div>
    </>
  );
}

export default PageHeading;
